module.exports = __webpack_public_path__ + "img/banner_visit_2.f6dacfea.png";